import React, { useState, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import {
  Button,
  Card,
  CardBody,
  CardText,
  CardSubtitle,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Alert,
} from "reactstrap"
import classnames from "classnames"
import BasicInfoTab from "./tabs/BasicInfoTab"
import {
  getUserDetail as onGetUserDetail,
  getUserProfile as onGetUserProfile,
  getPayrates as onGetPayrates,
} from "store/actions"
import { isEmpty } from "lodash"
import EmptyContainer from "components/Common/EmptyContainer"
import Document from "components/Common/Document"
import { EnumObjectTypes } from "helpers/enum_helper"
// import { ToastContainer } from "react-toastify"

import AvailabilityModal from "./modal/AvailabilityModal"
import Availability from "./misc/Availability"

import EmergencyContactModal from "./modal/EmergencyContactModal"
import EmergencyContact from "./misc/EmergencyContact"
import Notes from "./misc/Notes"
import NotesModal from "./modal/NotesModal"
import { useDeepCompareEffect, useUserDetail } from "hooks"
import { EnumRoleTypes } from "helpers/enum_helper"
import { useRole } from "hooks/useRole"

const UserAddEdit = () => {
  const navigate = useNavigate()
  const routeParams = useParams()
  const dispatch = useDispatch()
  const [header, setHeader] = useState("")
  const [tabValue, setTabValue] = useState("1")
  const [availabilityModal, setAvailabilityModal] = useState(false)
  const [emergencyContactModal, setEmergencyContactModal] = useState(false)
  const [notesModal, setNotesModal] = useState(false)
  const [revealed, setRevealed] = useState(false)
  //const { roleLabel } = useRole()
  const [roleLabel, setRoleLabel] = useState("User")

  useDeepCompareEffect(() => {
    const { id } = routeParams
    if (id === "new") {
      setHeader("Add " + roleLabel)
    } else {
      setHeader("Edit " + roleLabel)
      dispatch(onGetUserDetail(id))
    }
  }, [dispatch, routeParams])

  //////////////////STAFF STATE/////////////////////
  const data = useSelector(state => state.user)
  //////////////////////////////////////

  //////////////////STAFF STATE/////////////////////
  const { userprofile } = useSelector(state => state.user)
  //////////////////////////////////////
  const { basicSetting } = useSelector(state => state.Layout)
  //meta title
  document.title =
    "Users | " + (basicSetting?.SiteName || process.env.REACT_APP_NAME)
  useEffect(() => {
    if (isEmpty(data.user)) {
      return
    }
    dispatch(onGetUserProfile(data.user.UserID))
  }, [data.user.UserID])

  const toggleTab = tab => {
    if (tabValue !== tab) {
      setTabValue(tab)
    }
  }

  const onAvailabilityModalClick = () => {
    setAvailabilityModal(true)
  }

  const onEmergencyContactModalClick = () => {
    setEmergencyContactModal(true)
  }

  const onNotesModalClick = () => {
    setNotesModal(true)
  }

  const onCloseModal = () => {
    setAvailabilityModal(false)
    setEmergencyContactModal(false)
    setNotesModal(false)
  }

  const toggleReveal = () => {
    setRevealed(!revealed)
  }

  const MiscLeftSection = (heading, buttonText, onClick, children) => {
    return (
      <div className="p-3 border-bottom">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="m-0 pt-2">{heading}</h5>
          </div>
          <div>
            <Button
              className="btn btn-light waves-effect btn btn-light btn-sm"
              onClick={onClick}
            >
              {buttonText}
            </Button>
          </div>
        </div>
        {children}
      </div>
    )
  }

  const NavItemTab = (navTitle, navValue, iconValue) => {
    return (
      <NavItem>
        <NavLink
          style={{ cursor: "pointer" }}
          className={classnames({
            active: tabValue === navValue,
          })}
          onClick={() => {
            toggleTab(navValue)
          }}
        >
          <span className="d-block d-sm-none">
            <i className={iconValue}></i>
          </span>
          <span className="d-none d-sm-block">{navTitle}</span>
        </NavLink>
      </NavItem>
    )
  }

  return (
    <React.Fragment>
      {!isEmpty(data.user) ? (
        <>
          {availabilityModal && (
            <AvailabilityModal
              show={availabilityModal}
              onCloseClick={() => onCloseModal()}
              userID={data.user.UserID}
            />
          )}
          {emergencyContactModal && (
            <EmergencyContactModal
              show={emergencyContactModal}
              onCloseClick={() => onCloseModal()}
              userID={data.user.UserID}
              profile={userprofile}
            />
          )}
          {notesModal && (
            <NotesModal
              show={notesModal}
              onCloseClick={() => onCloseModal()}
              userID={data.user.UserID}
              profile={userprofile}
            />
          )}
        </>
      ) : (
        ""
      )}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={roleLabel} breadcrumbItem={header} />
          {routeParams.id !== "new" && isEmpty(data.user) ? (
            <EmptyContainer
              backURL="/users"
              message={`There is no such ${roleLabel}`}
              linkText={`Go to ${roleLabel} Page`}
            />
          ) : (
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <CardTitle>Basic Information</CardTitle>
                    <p className="card-title-desc mb-4">
                      Fill all information below to Complete the {roleLabel}{" "}
                      Details Below
                    </p>
                    {routeParams.id !== "new" ? (
                      <Nav tabs className="nav-tabs-custom nav-justified">
                        {NavItemTab(
                          "Basic Info",
                          "1",
                          "mdi mdi-information-outline"
                        )}
                        {NavItemTab("Misc", "2", "mdi mdi-kodi")}
                        {NavItemTab("Documents", "3", "mdi mdi-file-document")}
                      </Nav>
                    ) : (
                      ""
                    )}
                    <TabContent activeTab={tabValue} className="p-3 text-muted">
                      <TabPane tabId="1">
                        <Row>
                          <Col sm="12">
                            <BasicInfoTab {...data} />
                          </Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="2">
                        <Row>
                          <Col className="col-4">
                            <div className="p-3 rounded border h-100">
                              {MiscLeftSection(
                                "General Availability",
                                "Edit",
                                () => onAvailabilityModalClick(),
                                <Availability userID={data.user.UserID} />
                              )}
                              {MiscLeftSection(
                                "Emergency contact",
                                "Edit",
                                () => onEmergencyContactModalClick(),
                                <EmergencyContact profile={userprofile} />
                              )}
                              {MiscLeftSection(
                                "Notes",
                                "Edit",
                                () => onNotesModalClick(),
                                <Notes profile={userprofile} />
                              )}
                            </div>
                          </Col>
                          <Col className="col-8"></Col>
                        </Row>
                      </TabPane>
                      <TabPane tabId="3">
                        <Row>
                          <Col sm="12">
                            <Document
                              objectID={data.user.UserID}
                              objectTypeID={EnumObjectTypes.User}
                              hidePrivacy={true}
                            />
                          </Col>
                        </Row>
                      </TabPane>
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </Container>
      </div>
      {/* <ToastContainer /> */}
    </React.Fragment>
  )
}

export default UserAddEdit
